import { Component, OnInit, Input, HostListener } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { MastersKeyStringValue } from "src/app/services/Non-Master/MastersKeyStringValue.service";
import { Router } from "@angular/router";
import { SystemDefaultModel } from "src/app/models/non-master-model/SystemDefaultModel";
import { AppSettings } from "src/app/shared/AppSettings";
import { DisplayData } from "src/app/models/non-master-model/DisplayData";
import {
  CancelAction,
  ConfirmAction,
} from "../physio-completed/physio-completed.component";

@Component({
  selector: "app-xray-completed",
  templateUrl: "./xray-completed.component.html",
  styleUrls: ["./xray-completed.component.css"],
})
export class XrayCompletedComponent implements OnInit {
  isLoading = true;
  bntStyle = "btn-default";
  msg = "";

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.msg = "";
  }

  confirm() {
    this.activeModal.close(new ConfirmAction());
  }

  cancel() {
    this.activeModal.close(new CancelAction());
  }
}
